import { AttributionSector } from '@products/models/attribution';
import { AttributionSectorDTO, CurrencyCode, FundId } from '@types';
import { MapperFactory } from './mapper-factory';
import { Mapper, MapperParams } from './type.mapper';

export class AttributionSectorsMapper extends Mapper<AttributionSector[]> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(attributionSectorsDTO: AttributionSectorDTO[]): AttributionSector[] {
    const attributionSectors: AttributionSector[] = [];

    attributionSectorsDTO.forEach(
      (attributionSectorDTO: AttributionSectorDTO) => {
        const attributionSector: AttributionSector = this.createMapper(
          AttributionSectorMapper
        ).toDomain(attributionSectorDTO);

        if (attributionSector) {
          attributionSectors.push(attributionSector);
        }
      }
    );

    return attributionSectors;
  }
}

export class AttributionSectorMapper extends Mapper<AttributionSector> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(attributionSectorDTO: AttributionSectorDTO): AttributionSector {
    return {
      fundId: attributionSectorDTO.fundid as FundId,
      fundName: attributionSectorDTO.fundname,
      currency: attributionSectorDTO.currency as CurrencyCode,
      startDate: attributionSectorDTO.startdate,
      endDate: attributionSectorDTO.enddate,
      startDateStd: attributionSectorDTO.startdatestd,
      endDateStd: attributionSectorDTO.enddatestd,
      benchmark: attributionSectorDTO.benchmark,
      portfolioAverageWeight: attributionSectorDTO.portavgweight,
      portfolioTotalReturn: attributionSectorDTO.portreturn,
      portfolioContributionToReturn: attributionSectorDTO.portcontrib,
      bmAverageWeight: attributionSectorDTO.bmavgweight,
      bmTotalReturn: attributionSectorDTO.bmreturn,
      bmContributionToReturn: attributionSectorDTO.bmcontrib,
      variationAverageWeight: attributionSectorDTO.variationavgweight,
      variationTotalReturn: attributionSectorDTO.variationreturn,
      variationContributionToReturn: attributionSectorDTO.variationcontrib,
      allocationEffectLocal: attributionSectorDTO.alloceffectlocal,
      selectionEffectLocal: attributionSectorDTO.selecteffectlocal,
      interactionEffectLocal: attributionSectorDTO.interacteffectlocal,
      totalEffectLocal: attributionSectorDTO.totaleffectlocal,
      totalCurrencyEffect: attributionSectorDTO.currencyeffect,
      allocationEffect: attributionSectorDTO.alloceffect,
      selectionEffect: attributionSectorDTO.selecteffect,
      interactionEffect: attributionSectorDTO.interacteffect,
      totalEffect: attributionSectorDTO.totaleffect,
      portfolioCurReturn: attributionSectorDTO.portcurreturn,
      portfolioContributionLocal: attributionSectorDTO.portcontriblocal,
      portfolioReturnLocal: attributionSectorDTO.portreturnlocal,
      toDateStd: attributionSectorDTO.todatestd,
      fromDateStd: attributionSectorDTO.fromdatestd,
      toDate: attributionSectorDTO.todate,
      fromDate: attributionSectorDTO.fromdate,
      levelNumber: attributionSectorDTO.levelno,
      numberOfMonths: attributionSectorDTO.noofmonths,
      calcType: attributionSectorDTO.calctype,
      bmReturnLocal: attributionSectorDTO.bmreturnlocal,
      sector: attributionSectorDTO.sector,
      industry: attributionSectorDTO.industry,
    };
  }
}
